import { Link } from "react-router-dom";
import { ShoppingBag, Heart } from "lucide-react";
import { useCart } from "@/context/CartContext";
import { useWishlist } from "@/context/WishlistContext";
import { ShareButton } from "@/components/ShareButton";

export const Header = () => {
  const { count, setOpen } = useCart();
  const { ids } = useWishlist();
  return (
    <header className="sticky top-0 z-40 bg-[#FBFBFB] border-b border-[#0F0F0F]">
      <div className="max-w-[1400px] mx-auto px-3 sm:px-5 md:px-10 h-16 flex items-center justify-between gap-2">
        <Link to="/" data-testid="header-logo-link" className="font-display font-black text-lg sm:text-2xl tracking-tight whitespace-nowrap">
          SCONTO<span className="text-[#FF3333]">.</span>MARKET
        </Link>
        <nav className="flex items-center gap-1.5 sm:gap-2 md:gap-6">
          <Link to="/traccia" data-testid="header-track-link" className="tag hidden sm:block hover:text-[#FF3333]">
            Traccia ordine
          </Link>
          <ShareButton />
          <Link to="/preferiti" data-testid="header-wishlist-link" className="btn-ghost h-10 px-2 sm:px-3 flex items-center gap-1.5 sm:gap-2">
            <Heart size={18} strokeWidth={1.5} />
            <span className="font-mono text-sm" data-testid="header-wishlist-count">{ids.length}</span>
          </Link>
          <button
            data-testid="header-cart-button"
            onClick={() => setOpen(true)}
            className="btn-ghost h-10 px-2 sm:px-4 flex items-center gap-1.5 sm:gap-2"
          >
            <ShoppingBag size={18} strokeWidth={1.5} />
            <span className="font-mono text-sm" data-testid="header-cart-count">{count}</span>
          </button>
        </nav>
      </div>
    </header>
  );
};
